'use client'

import type { VariantProps } from '@gluestack-ui/nativewind-utils'
import { tva } from '@gluestack-ui/nativewind-utils/tva'
import { withStyleContext } from '@gluestack-ui/nativewind-utils/withStyleContext'
import { createTextarea } from '@gluestack-ui/textarea'
import React from 'react'
import { TextInput, View } from 'react-native'

const SCOPE = 'TEXTAREA'
const UITextarea = createTextarea({
  Root: withStyleContext(View, SCOPE),
  Input: TextInput
})

const textareaStyle = tva({
  base: 'h-[100px] w-full rounded border border-background-300 data-[focus=true]:border-primary-700 data-[focus=true]:data-[hover=true]:border-primary-700 data-[hover=true]:border-outline-400 data-[disabled=true]:data-[hover=true]:border-background-300 data-[disabled=true]:bg-background-50 data-[disabled=true]:opacity-40',

  variants: {
    variant: {
      default:
        'data-[invalid=true]:border-error-700 data-[invalid=true]:web:ring-1 data-[invalid=true]:web:ring-inset data-[invalid=true]:web:ring-indicator-error data-[invalid=true]:data-[hover=true]:border-error-700 data-[invalid=true]:data-[focus=true]:data-[hover=true]:web:ring-inset data-[invalid=true]:data-[focus=true]:data-[hover=true]:web:ring-indicator-primary data-[invalid=true]:data-[focus=true]:data-[hover=true]:web:ring-1 data-[invalid=true]:data-[focus=true]:data-[hover=true]:border-primary-700 data-[invalid=true]:data-[disabled=true]:data-[hover=true]:web:ring-inset data-[invalid=true]:data-[disabled=true]:data-[hover=true]:web:ring-indicator-error data-[invalid=true]:data-[disabled=true]:data-[hover=true]:web:ring-1 data-[invalid=true]:data-[disabled=true]:data-[hover=true]:border-error-700 data-[focus=true]:border-primary-700 data-[focus=true]:web:ring-1 data-[focus=true]:web:ring-inset data-[focus=true]:web:ring-indicator-primary'
    },
    size: {
      sm: '',
      md: '',
      lg: '',
      xl: ''
    }
  }
})

const textareaInputStyle = tva({
  base: 'flex-1 p-2 align-text-top text-typography-900 placeholder:text-typography-500 web:cursor-text web:outline-none web:outline-0 web:data-[disabled=true]:cursor-not-allowed',
  parentVariants: {
    size: {
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl'
    }
  }
})

type TextAreaProps = React.ComponentProps<typeof UITextarea> & VariantProps<typeof textareaStyle>

const TextArea = React.forwardRef<React.ComponentRef<typeof UITextarea>, TextAreaProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    return (
      <UITextarea
        ref={ref}
        {...props}
        className={textareaStyle({ variant, class: className })}
        context={{ size }}
      />
    )
  }
)

type TextAreaInputProps = React.ComponentProps<typeof UITextarea.Input> & VariantProps<typeof textareaInputStyle>

const TextAreaInput = React.forwardRef<React.ComponentRef<typeof UITextarea.Input>, TextAreaInputProps>(
  ({ accessibilityLabel, className, ...props }, ref) => {
    // const { size: parentSize } = useStyleContext(SCOPE)

    return (
      <UITextarea.Input
        aria-label={accessibilityLabel}
        ref={ref}
        textAlignVertical='top'
        {...props}
        className={textareaInputStyle({
          // parentVariants: {
          //   size: parentSize
          // },
          class: className
        })}
      />
    )
  }
)

TextArea.displayName = 'TextArea'
TextAreaInput.displayName = 'TextAreaInput'

export { TextArea, TextAreaInput, type TextAreaProps, type TextAreaInputProps }
